import { SVGProps } from 'react'

export const ServicePeopleSvg = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      version='1.1'
      viewBox='0 0 1024 1024'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M291.99127701 411.49330832A219.95279819 219.95279819 0 1 0 511.94407519 191.11866974a220.15131098 220.15131098 0 0 0-219.95279818 220.37463858z' />
      <path d='M682.54148972 609.38630972a220.25056778 220.25056778 0 0 1-341.17001587 0C214.54625449 652.19075164 127.34926258 760.75274353 127.34926258 863.58266128c0 93.72311801 769.23925241 93.72311801 769.23925322 0-0.02481399-102.97880337-87.22180591-211.39190964-214.04702608-254.19635156z m132.83024907-287.54659534a314.5195978 314.5195978 0 0 0-606.75607122-0.27295559 80.84456377 80.84456377 0 0 0-60.02547583 81.31603299 78.36314694 78.36314694 0 0 0 72.55663165 82.43267102c19.62800794 0 29.47923331-40.54635269 29.55367529-82.30860022h0.81886762a260.54877888 260.54877888 0 0 1 520.65090336-9.92566819c-1.66254923 44.24366437 8.13904733 92.23426758 29.3799765 92.23426841a78.48721775 78.48721775 0 0 0 72.55663165-82.58155582 81.09270539 81.09270539 0 0 0-58.73513902-80.8941926z' />
    </svg>
  )
}
